<template>
  <div
    class="d-flex align-items-center"
    :class="[{ 'pipeline-status': !onlyIcon }, wrapperAdditionalClass]"
    :style="{ 'border-color': '#' + status.hexColor, color: '#' + status.hexColor }"
  >
    <span
      class="d-flex align-items-center"
      :class="{ 'mr-1': this.showTitle && !this.onlyIcon }"
    >
      <i :class="iconClass + iconFontClass"></i>
    </span>
    <template v-if="showTitle && !onlyIcon">
      <small v-if="isSmall">{{ status.title }}</small>
      <span v-else>{{ status.title }}</span>
    </template>
  </div>
</template>

<script>
import { PIPELINE_STATUS_ENUM } from '@shared/modules/ci-cd/ci-cd.constants';

export default {
  name: 'CiMainStatus',
  props: {
    status: {
      default: null,
      type: Object
    },
    showTitle: {
      default: true,
      type: Boolean
    },
    onlyIcon: {
      default: false,
      type: Boolean
    },
    size: {
      default: 1,
      type: Number
    },
    position: {
      default: 'top',
      type: String
    },
    iconSize: {
      default: 0,
      type: Number
    },
    wrapperAdditionalClass: {
      type: String,
      default: ''
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { PIPELINE_STATUS_ENUM };
  },
  computed: {
    iconClass() {
      let iconClass = '';
      switch (this.status.id) {
        case PIPELINE_STATUS_ENUM.CREATED:
          iconClass = 'gf-icon gf-icon-plus-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.PENDING:
          iconClass = 'gf-icon gf-icon-pause-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.RUNNING:
          iconClass = 'gf-icon gf-icon-play-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.SUCCESS:
          iconClass = 'gf-icon gf-icon-check-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.FAILED:
          iconClass = 'gf-icon gf-icon-warning mr-1-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.CANCELED:
          iconClass = 'gf-icon gf-icon-stop-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.SKIPPED:
          iconClass = 'gf-icon gf-icon-skip-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.MANUAL:
          iconClass = 'gf-icon gf-icon-person-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.SCHEDULED:
          iconClass = 'gf-icon gf-icon-person-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.PREPARING:
          iconClass = 'gf-icon gf-icon-pause-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.WAITING_FOR_RESOURCE:
          iconClass = 'gf-icon gf-icon-pause-circle';
          return iconClass;

        case PIPELINE_STATUS_ENUM.WARNING:
          iconClass = 'gf-icon gf-icon-info';
          return iconClass;

        default:
          iconClass = 'gf-icon gf-icon-info-circle';
          return iconClass;
      }
    },
    iconFontClass() {
      let iconStyle = '';

      switch (this.iconSize) {
        case 1:
          iconStyle += ' gf-fs-1';
          return iconStyle;
        case 2:
          iconStyle += ' gf-fs-2';
          return iconStyle;
        case 3:
          iconStyle += ' gf-fs-3';
          return iconStyle;
        case 4:
          iconStyle += ' gf-fs-4';
          return iconStyle;
        case 5:
          iconStyle += ' gf-fs-5';
          return iconStyle;
        case 6:
          iconStyle += ' gf-fs-6';
          return iconStyle;
        case 7:
          iconStyle += ' gf-fs-7';
          return iconStyle;
        case 8:
          iconStyle += ' gf-fs-8';
          return iconStyle;
        case 9:
          iconStyle += ' gf-fs-9';
          return iconStyle;
        default:
          return iconStyle;
      }
    }
  }
};
</script>

<style lang="scss">
$this: '.pipeline-status';

#{$this} {
  height: fit-content;
  width: fit-content;
  display: inline-block;
  border: 1px solid #cccccc;
  border-radius: 20px;
  padding: 2px 6px;
}
</style>
